<div class="helpline-widget">

  <div class="helpline-widget__text">
    <button mat-raised-button class="btn--text">
      {{ 'HELPLINE_WIDGET.BUTTON_TEXT' | translate }}
      <span class="material-icons">arrow_drop_down</span>
    </button>
    <div class="helpline-widget__text__phone-number">
      <span class="material-icons">phone</span>
      {{ phoneNumber | translate }}
    </div>
  </div>

  <div class="helpline-widget__image">
    <img [src]="imageSrc" alt="">
    <div class="helpline-widget__image__border"></div>
  </div>
</div>
